import { createContext, ReactElement, useState } from "react";
import { CategoryType, MainTopicType } from "../types/types";


type CategoryContextProps = {
  category?: CategoryType;
  setCategory(val: CategoryType  | undefined): void;
  mainTopic?: MainTopicType;
  setMainTopic(val: MainTopicType  | undefined): void;
}

export const CategoryContext = createContext<CategoryContextProps>({
  setCategory: () => undefined,
  setMainTopic: () => undefined

});

type CategoryContextProviderProps = {
  children: ReactElement;
}

export function CategoryContextProvider({ children }: CategoryContextProviderProps) {

  const [category, setCategory] = useState<CategoryType   | undefined>(undefined);
  const [mainTopic, setMainTopic] = useState<MainTopicType | undefined>(undefined);


  return (
    <CategoryContext.Provider value={{
      category,
      setCategory,
      mainTopic,
      setMainTopic
    }}>
      {children}
    </CategoryContext.Provider>
  )
}